import React, { ReactNode } from "react";

import cn from "classnames";

import styles from "./DynamicVariableChip.module.scss";

interface EmailDynamicVariableChipProps {
  allEntitiesHaveValues?: boolean;
  children: ReactNode;
  className?: string;
  greyed?: boolean;
  onClick?: () => void;
}

const EmailDynamicVariableChip = ({
  allEntitiesHaveValues,
  children,
  className,
  greyed,
  onClick,
}: EmailDynamicVariableChipProps) => {
  return (
    <span
      className={cn(
        styles.container,
        {
          [styles.greyed]: greyed,
          [styles.warn]: !greyed && allEntitiesHaveValues === false,
        },
        className
      )}
      onClick={onClick}
    >
      {children}
    </span>
  );
};

export default EmailDynamicVariableChip;
